"use client";

import { c as _c } from "react/compiler-runtime";
import type { MouseEventHandler, ReactNode } from 'react';
import Div100Vh from 'src/components/div100vh/Div100Vh';
import OverlayPortal from "src/components/overlayportal/OverlayPortal";
import CloseSvg from 'src/components/svg/CloseSvg';
import styles from "./FullPageOverlay.module.css";
import getThemeStyles from "src/lib/styling/getThemeStyles";
import classNames from "classnames";

//#region [Props]
type FullPageOverlayProps = {
  children: ReactNode;
  onClose?: () => void;
  hideCloseButton?: boolean;
  closeOnClick?: boolean;
};
//#endregion

//#region [Component]
export default function FullPageOverlay(t0) {
  const $ = _c(15);
  const {
    children,
    onClose,
    hideCloseButton: t1,
    closeOnClick: t2
  } = t0;
  const hideCloseButton = t1 === undefined ? false : t1;
  const closeOnClick = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== closeOnClick || $[1] !== onClose) {
    t3 = closeOnClick && onClose ? event => {
      if (event.currentTarget === event.target) {
        onClose();
      }
    } : undefined;
    $[0] = closeOnClick;
    $[1] = onClose;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const onClick = t3;
  let T0;
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    const theme = getThemeStyles(styles);
    T0 = OverlayPortal;
    t4 = true;
    t5 = classNames(styles.Portal, theme);
    $[3] = T0;
    $[4] = t4;
    $[5] = t5;
  } else {
    T0 = $[3];
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== children) {
    t6 = <div className={styles.SOverlayContent}>{children}</div>;
    $[6] = children;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== hideCloseButton || $[9] !== onClose) {
    t7 = !hideCloseButton && <button className={styles.SCloseButton} onClick={onClose}><CloseSvg /></button>;
    $[8] = hideCloseButton;
    $[9] = onClose;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== onClick || $[12] !== t6 || $[13] !== t7) {
    t8 = <T0 hideClose={t4} className={t5}><Div100Vh className={styles.SFullPageOverlay} onClick={onClick}>{t6}{t7}</Div100Vh></T0>;
    $[11] = onClick;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}
//#endregion